import {useCallback} from 'react'
import {useLazyQuery, gql} from '@apollo/client'
import {useDispatch, useSelector} from 'react-redux'
import {
  selectNationChartVariables,
  setNationChartVariables as setNationChartVariablesAction,
  resetNationChartVariables as resetNationChartVariablesAction
} from '../slices/nationChartSlice'

const nationQuery = gql`
  query sdohPopulation($SDOH_KEY: AlphabetOnly!) {
    sdohPopulation(SDOH_KEY: $SDOH_KEY) {
      DATA_BRICK
      option_name
      option_count_per_100k
    }
  }
`

export function useQuerySdohNationChart(chartVariables) {
  const [
    getChartNationData,
    {data: chartData, loading: loadingChart, refetch: refetchChart, error: errorLoadingChart}
  ] = useLazyQuery(nationQuery, {
    context: {clientName: 'longitudinal'},
    variables: {
      SDOH_KEY: chartVariables?.sdohKey
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })
  return [getChartNationData, {chartData, loadingChart, refetchChart, errorLoadingChart}]
}

export const useNationChartProvider = () => {
  const dispatch = useDispatch()
  const nationChartVariables = useSelector(selectNationChartVariables)

  const [getChartNationData, chartNationData] = useQuerySdohNationChart(nationChartVariables)

  const updateNationChartVariables = useCallback(
    (variables) => {
      dispatch(setNationChartVariablesAction(variables))
    },
    [dispatch]
  )

  const resetVariables = useCallback(() => {
    dispatch(resetNationChartVariablesAction())
  }, [dispatch])

  return {
    nationChartVariables,
    getChartNationData,
    chartNationData,
    setNationChartVariables: updateNationChartVariables,
    resetNationChartVariables: resetVariables
  }
}
